import {OrderItem} from '@/app/shop/features/orders/model/order-item.ts';


export class ShoppingCart {
  public uuid!: string;
  public number!: number;
  public listOrderItem: Array<OrderItem> = [];
}
